module.exports = __webpack_public_path__ + "img/e_2_8_r.5dfdfe72.png";